import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";
import {execute} from "fg-frontend/src/partialUpdate/partialUpdate";

const fragments = {
	CLAIM: '[data-fragment="EmployeePaymentsListing.claim"]',
	PEREX_TEXT: '[data-fragment="EmployeePaymentsListing.perexText"]',
};


class EmployeePaymentsListing extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);

		const jsonMessagesComponentElement = document.getElementById('jsonMessages');
		this.jsonMessagesComponent = getWebComponentInstance(jsonMessagesComponentElement);

		this.perexTextElement = this.element.querySelector(fragments.PEREX_TEXT);

		this.on('click', fragments.CLAIM, this.handleClickOnClaim);

		this.employeePaymentsTextElement = this.element.querySelector('[id$="employeeSummaryListing"]');
		this.entitlementId = this.getEntitlementId();
		this.branchId = this.getBranchId();
		this.monthId = this.getMonthId()
		this.yearId = this.getYearId();
	}

	handleClickOnClaim = (e) => {
		e.preventDefault();
		this.commitChanges(e);
	}


	commitChanges = (e) => {


		this.universalPreloaderComponent.handleOn(10);
		let dataJSON = [];
		let commitUrl = '/canteen/employeePaymentsListing?&csrf=' + this.getCsrfToken() + '&eventName.changeCanteenPaymentState';
		let xmlHttpReq = new XMLHttpRequest();
		let _self = this;

		let newStateValue = false;
		if(e.target.getAttribute('data-state') === 'false') {
			newStateValue = true;
		}
		const localDateValue = e.target.parentElement.parentElement.getAttribute('data-local-date');
		dataJSON = {
			employeeId: parseInt(this.getEmployeeId()),
			branchId: parseInt(this.getBranchId()),
			date: localDateValue,
			newState: newStateValue,
		};

		xmlHttpReq.open('POST', commitUrl, true);
		xmlHttpReq.setRequestHeader("Content-Type", "application/json");
		xmlHttpReq.onreadystatechange = function () {
			if (xmlHttpReq.readyState === 4) {
				if (xmlHttpReq.status === 200) {
					let data = JSON.parse(xmlHttpReq.responseText);
					if (data.ok) {
						e.target.setAttribute('data-state', newStateValue);
						e.target.parentElement.parentElement.setAttribute('data-claim', newStateValue);
						if(newStateValue){
							e.target.children[0].classList.remove('svg-icon--danger');
							e.target.children[0].classList.add('svg-icon--secondary');
						} else {
							e.target.children[0].classList.add('svg-icon--danger');
							e.target.children[0].classList.remove('svg-icon--secondary');
						}
						execute({
							url: '/canteen/employeePaymentsListing?entitlementId=' + _self.entitlementId,
							target: _self.employeePaymentsTextElement.id,
						});
						if(window.location.pathname === '/canteen/canteenEntitlement') {
							execute({
								url: window.location.pathname + "?frm.branchId=" + _self.branchId + "&frm.month=" + _self.monthId + "&frm.year=" + _self.yearId,
								target: 'entitlementToMealListing',
							});
						}
					}
					if(data.error) {
						_self.jsonMessagesComponent.showAlert('danger', data.errorMessage);
					}
				}
			}
			_self.universalPreloaderComponent.handleOff(10);
		};
		xmlHttpReq.send(JSON.stringify(dataJSON));
	}

	getBranchId = () => {
		return document.querySelector('form[id$=employeePaymentsForm] input[name="branchId"]').value;
	}

	getMonthId = () => {
		return document.querySelector('form[id$=employeePaymentsForm] input[name="month"]').value;
	}

	getYearId = () => {
		return document.querySelector('form[id$=employeePaymentsForm] input[name="year"]').value;
	}

	getEmployeeId = () => {
		return document.querySelector('form[id$=employeePaymentsForm] input[name="employeeId"]').value;
	}

	getEntitlementId = () => {
		return document.querySelector('form[id$=employeePaymentsForm] input[name="entitlementId"]').value;
	}

	getCsrfToken = () => {
		return document.querySelector('form[id$=employeePaymentsForm] input[name=csrf]').value;
	};

}

export default EmployeePaymentsListing;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Canteen/EmployeePaymentsListing.js